import { Currency } from "@goodfill/domain-properties";

export const CurrencyComponent = (props: { currency: Currency }) => {
  if (props.currency === "USD") {
    return <>$</>;
  }
  // if (props.currency === "EUR") return <>€</>;
  if (props.currency === "JPY") {
    return <>¥</>;
  }

  return props.currency;
};
